import "./index.css";
import AppRoutes from "./routes/AppRoutes";
import { useAuth } from "./auth/AuthContext";

function App() {

  const { loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", padding: "2rem" }}>
        <span className="spinner-loader"></span>
        <span>Carregando...</span>
      </div>
    );
  }

  return (
    <div>
      <AppRoutes />
      <footer className="footer" style={{ textAlign: "right", right: "10px" }}>
        <p className="footer-box">Desenvolvido por: Fernando da Silva Costa</p>
        <p className="footer-box">Versão: 1.0.0</p>
      </footer>
    </div>
  );
}

export default App;
